/* eslint-disable no-unused-vars */
import Environment from "../../utils/environment";
import axios from "..";
import {
  ytdSpends,
  ytdAuthorisations,
  auhorisationsByPolicy,
  spendsByPolicy,
  exceptionsByPolicy,
  upcomingVisaExp,
  mapsData,
  getDivisions,
  GET_SERVICE_BY_POLICY,
  CHECK_FAVOURITE_NAME,
  CREATE_FAVOURITE,
  ExportData,
  ytdActiveFiles,
  assignmentExpCountURL,
  assignmentExpirationURL,
} from "../../resources/constants";

export interface ILandingInfo {
  id: number;
  title: string;
  description: string;
  background?: string;
  error: any;
  data: [];
}

enum Landing {
  LANDING_PAGE = "landing",
}

export default class dashboardService {
  public static async getYtdSpends(filters: any) {
    return { data: {} };
    try {
      const { data }: { data: any } = await axios.post(ytdSpends, filters);
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getYtdAuthorisations(filters: any) {
    return { data: {} };
    try {
      const { data }: { data: any } = await axios.post(
        ytdAuthorisations,
        filters,
      );
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getYtdActiveFiles(filters: any) {
    return { data: {} };
    try {
      const { data }: { data: any } = await axios.post(ytdActiveFiles, filters);
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getAuthsByPolicy(filters: any) {
    return {
      authorisationsByPolicy: [
        {
          fileNumberCount: 10,
          program_name: "US Domestic Renter",
        },
        {
          fileNumberCount: 30,
          program_name: "US Domestic Homeowner",
        },
        {
          fileNumberCount: 18,
          program_name: "US Domestic Assignment - Managed Lump Sum",
        },
        {
          fileNumberCount: 2,
          program_name: "Rotational Assignment",
        },
        {
          fileNumberCount: 7,
          program_name: "International STA	Managed Lump Sum",
        },
        {
          fileNumberCount: 11,
          program_name: "International Permanent",
        },
        {
          fileNumberCount: 1,
          program_name: "International LTA",
        },
      ],
      startDate: "2022-06-26 00:00:00",
      endDate: "2025-07-17 00:00:00",
    };

    try {
      const { data }: { data: any } = await axios.post(
        auhorisationsByPolicy,
        filters,
      );
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getSpendsByPolicy(filters: any) {
    return {
      spendsByPolicy: [
        {
          program_name: "International LTA",
          totalAmount: 66350.0,
        },
        {
          program_name: "International Permanent",
          totalAmount: 2500.0,
        },
        {
          program_name: "International STA",
          totalAmount: 64750.0,
        },
        {
          program_name: "Rotational Assignment",
          totalAmount: 2500.0,
        },
        {
          program_name: "US Domestic Homeowner",
          totalAmount: 1458.25,
        },
        {
          program_name: "US Domestic Renter",
          totalAmount: 46000.0,
        },
      ],
      startDate: "2021-07-12 00:00:00",
      endDate: "2025-07-25 00:00:00",
    };
    try {
      const { data }: { data: any } = await axios.post(spendsByPolicy, filters);
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }
  public static async getExportsData(filters: any) {
    return { data: {} };
    try {
      const { data }: { data: any } = await axios.post(ExportData, filters);
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getExceptionsByPolicy(filters: any) {
    return {
      exceptionsByPolicy: [
        {
          program_name: "International Permanent",
          totalAmount: 22020.52,
        },
        {
          program_name: "International STA	Managed Lump Sum",
          totalAmount: 18243.58,
        },
        {
          program_name: "US Domestic Renter",
          totalAmount: 4793.75,
        },
        {
          program_name: "US Domestic Assignment - Managed Lump Sum",
          totalAmount: 3957,
        },
      ],
      startDate: "2022-07-03 00:00:00",
      endDate: "2025-08-09 00:00:00",
    };
    try {
      const { data }: { data: any } = await axios.post(
        exceptionsByPolicy,
        filters,
      );
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getVisaExpiryPolicy(filters: any) {
    return { data: {} };
    try {
      const { data }: { data: any } = await axios.post(
        upcomingVisaExp,
        filters,
      );
      return data;
    } catch (error: any) {
      throw new Error(error.error.message);
    }
  }

  public static async getMapsData(filters: any) {
    // const { data }: { data: any } = await axios.post(mapsData, filters);

    if (filters.filters.domestic === "true") {
      return JSON.parse(`{
      "mapsData": {
        "originStates": [
          {
            "count": 22,
            "originState": "KY"
          },
          {
            "count": 46,
            "originState": "LA"
          },
          {
            "count": 33,
            "originState": "MA"
          },
          {
            "count": 35,
            "originState": "MD"
          },
          {
            "count": 3,
            "originState": "ME"
          },
          {
            "count": 43,
            "originState": "MI"
          },
          {
            "count": 27,
            "originState": "MN"
          },
          {
            "count": 26,
            "originState": "MO"
          },
          {
            "count": 21,
            "originState": "MS"
          }
        ],
        "destinationStates": [
          {
            "count": 22,
            "destinationState": "KY"
          },
          {
            "count": 46,
            "destinationState": "LA"
          },
          {
            "count": 33,
            "destinationState": "MA"
          },
          {
            "count": 35,
            "destinationState": "MD"
          },
          {
            "count": 3,
            "destinationState": "ME"
          },
          {
            "count": 43,
            "destinationState": "MI"
          },
          {
            "count": 27,
            "destinationState": "MN"
          },
          {
            "count": 26,
            "destinationState": "MO"
          },
          {
            "count": 21,
            "destinationState": "MS"
          }
        ]
      }
    }`);
    } else {
      return JSON.parse(`{
          "mapsData": {
            "destinationCountries": [
              {
                "count": 1,
                "destinationCountry": "AFG"
              },
              {
                "count": 4,
                "destinationCountry": "ARE"
              },
              {
                "count": 8,
                "destinationCountry": "AUS"
              },
              {
                "count": 1,
                "destinationCountry": "BEL"
              },
              {
                "count": 2,
                "destinationCountry": "BHS"
              },
              {
                "count": 1,
                "destinationCountry": "BRA"
              },
              {
                "count": 86,
                "destinationCountry": "CAN"
              },
              {
                "count": 30,
                "destinationCountry": "CHE"
              },
              {
                "count": 4,
                "destinationCountry": "CHL"
              },
              {
                "count": 23,
                "destinationCountry": "CHN"
              },
              {
                "count": 10,
                "destinationCountry": "CZE"
              },
              {
                "count": 8,
                "destinationCountry": "DEU"
              },
              {
                "count": 1,
                "destinationCountry": "DNK"
              },
              {
                "count": 1,
                "destinationCountry": "DZA"
              },
              {
                "count": 3,
                "destinationCountry": "ESP"
              },
              {
                "count": 53,
                "destinationCountry": "FRA"
              },
              {
                "count": 52,
                "destinationCountry": "GBR"
              },
              {
                "count": 1,
                "destinationCountry": "GUY"
              },
              {
                "count": 8,
                "destinationCountry": "HKG"
              },
              {
                "count": 1,
                "destinationCountry": "HUN"
              },
              {
                "count": 6,
                "destinationCountry": "IND"
              },
              {
                "count": 7,
                "destinationCountry": "IRL"
              },
              {
                "count": 1,
                "destinationCountry": "ISR"
              },
              {
                "count": 1,
                "destinationCountry": "ITA"
              },
              {
                "count": 7,
                "destinationCountry": "JPN"
              },
              {
                "count": 7,
                "destinationCountry": "KOR"
              },
              {
                "count": 1,
                "destinationCountry": "LBN"
              },
              {
                "count": 2,
                "destinationCountry": "MEX"
              },
              {
                "count": 2,
                "destinationCountry": "MYS"
              },
              {
                "count": 15,
                "destinationCountry": "NLD"
              },
              {
                "count": 2,
                "destinationCountry": "NOR"
              },
              {
                "count": 2,
                "destinationCountry": "PHL"
              },
              {
                "count": 4,
                "destinationCountry": "POL"
              },
              {
                "count": 3,
                "destinationCountry": "PRT"
              },
              {
                "count": 3,
                "destinationCountry": "QAT"
              },
              {
                "count": 2,
                "destinationCountry": "SAU"
              },
              {
                "count": 25,
                "destinationCountry": "SGP"
              },
              {
                "count": 2,
                "destinationCountry": "SWE"
              },
              {
                "count": 1,
                "destinationCountry": "SWZ"
              },
              {
                "count": 1,
                "destinationCountry": "TTO"
              },
              {
                "count": 3,
                "destinationCountry": "TUR"
              },
              {
                "count": 3,
                "destinationCountry": "TWN"
              },
              {
                "count": 2686,
                "destinationCountry": "USA"
              }
            ],
            "originCountries": [
              {
                "count": 1,
                "originCountry": "ALB"
              },
              {
                "count": 1,
                "originCountry": "ANT"
              },
              {
                "count": 5,
                "originCountry": "ARE"
              },
              {
                "count": 4,
                "originCountry": "AUS"
              },
              {
                "count": 2,
                "originCountry": "AUT"
              },
              {
                "count": 6,
                "originCountry": "BEL"
              },
              {
                "count": 1,
                "originCountry": "BGD"
              },
              {
                "count": 1,
                "originCountry": "BGR"
              },
              {
                "count": 1,
                "originCountry": "BHS"
              },
              {
                "count": 28,
                "originCountry": "BRA"
              },
              {
                "count": 1,
                "originCountry": "BRB"
              },
              {
                "count": 73,
                "originCountry": "CAN"
              },
              {
                "count": 9,
                "originCountry": "CHE"
              },
              {
                "count": 4,
                "originCountry": "CHL"
              },
              {
                "count": 15,
                "originCountry": "CHN"
              },
              {
                "count": 1,
                "originCountry": "COL"
              },
              {
                "count": 4,
                "originCountry": "CZE"
              },
              {
                "count": 14,
                "originCountry": "DEU"
              },
              {
                "count": 2,
                "originCountry": "DNK"
              },
              {
                "count": 2,
                "originCountry": "EGY"
              },
              {
                "count": 10,
                "originCountry": "ESP"
              },
              {
                "count": 1,
                "originCountry": "FIN"
              },
              {
                "count": 8,
                "originCountry": "FRA"
              },
              {
                "count": 41,
                "originCountry": "GBR"
              },
              {
                "count": 1,
                "originCountry": "GRC"
              },
              {
                "count": 13,
                "originCountry": "HKG"
              },
              {
                "count": 1,
                "originCountry": "HRV"
              },
              {
                "count": 1,
                "originCountry": "HUN"
              },
              {
                "count": 48,
                "originCountry": "IND"
              },
              {
                "count": 10,
                "originCountry": "IRL"
              },
              {
                "count": 7,
                "originCountry": "ITA"
              },
              {
                "count": 1,
                "originCountry": "JOR"
              },
              {
                "count": 6,
                "originCountry": "JPN"
              },
              {
                "count": 1,
                "originCountry": "KEN"
              },
              {
                "count": 11,
                "originCountry": "KOR"
              },
              {
                "count": 1,
                "originCountry": "LKA"
              },
              {
                "count": 1,
                "originCountry": "MCO"
              },
              {
                "count": 21,
                "originCountry": "MEX"
              },
              {
                "count": 2,
                "originCountry": "MLT"
              },
              {
                "count": 2,
                "originCountry": "MYS"
              },
              {
                "count": 10,
                "originCountry": "NLD"
              },
              {
                "count": 5,
                "originCountry": "NOR"
              },
              {
                "count": 1,
                "originCountry": "NZL"
              },
              {
                "count": 3,
                "originCountry": "OMN"
              },
              {
                "count": 5,
                "originCountry": "PHL"
              }
            ]
          }
        }`);
    }

    // return data;
  }

  public static async servicesByPolicy(filters: any) {
    return {
      data: {
        getServiceByPolicy: [
          {
            service: "Final Move",
            policy: "US Domestic Renter",
            totalAmount: 12066.83,
          },
          {
            service: "New Residence ",
            policy: "US Domestic Renter",
            totalAmount: 7728.25,
          },
          {
            service: "Old Residence ",
            policy: "US Domestic Renter",
            totalAmount: 14342.23,
          },
          {
            service: "Others",
            policy: "US Domestic Renter",
            totalAmount: 2428.54,
          },
          {
            service: "Return Trip ",
            policy: "US Domestic Renter",
            totalAmount: 1271.49,
          },
          {
            service: "Temporary Living ",
            policy: "US Domestic Renter",
            totalAmount: 11701.73,
          },
          {
            service: "Tenancy Management",
            policy: "US Domestic Renter",
            totalAmount: 12474.5,
          },
          {
            service: "Fee",
            policy: "US Domestic Homeowner",
            totalAmount: 73210,
          },
          {
            service: "Home Finding ",
            policy: "US Domestic Homeowner",
            totalAmount: 1283.52,
          },
          {
            service: "Household Goods ",
            policy: "US Domestic Homeowner",
            totalAmount: 728.18,
          },
          {
            service: "New Residence ",
            policy: "US Domestic Homeowner",
            totalAmount: 129,
          },
          {
            service: "Others",
            policy: "US Domestic Homeowner",
            totalAmount: 26080,
          },
          {
            service: "Cultural Training ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 9446.71,
          },
          {
            service: "Fee",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 39915,
          },
          {
            service: "Final Move",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 25115.09,
          },
          {
            service: "Home Sale Assistance",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: -500,
          },
          {
            service: "Old Residence ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 11291.37,
          },
          {
            service: "Rental Assistance ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 2680,
          },
          {
            service: "Temporary Living ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 35706.87,
          },
          {
            service: "Tenancy Management",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 19625.43,
          },
          {
            service: "Home Finding ",
            policy: "Rotational Assignment",
            totalAmount: 3343.32,
          },
          {
            service: "Household Goods ",
            policy: "Rotational Assignment",
            totalAmount: 163674.54,
          },
          {
            service: "Interest on Equity",
            policy: "Rotational Assignment",
            totalAmount: 1489.43,
          },
          {
            service: "Others",
            policy: "Rotational Assignment",
            totalAmount: 47043.21,
          },
          {
            service: "Fee",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 23315,
          },
          {
            service: "Final Move",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 48382.67,
          },
          {
            service: "Old Residence ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 203297.66,
          },
          {
            service: "Return Trip ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 12238.37,
          },
          {
            service: "Temporary Living ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 231085.05,
          },
          {
            service: "Cultural Training ",
            policy: "International Permanent",
            totalAmount: 1795,
          },
          {
            service: "Fee",
            policy: "International Permanent",
            totalAmount: 63430,
          },
          {
            service: "Final Move",
            policy: "International Permanent",
            totalAmount: 108311.77,
          },
          {
            service: "Home Sale Assistance",
            policy: "International Permanent",
            totalAmount: 64400,
          },
          {
            service: "Immigration",
            policy: "International Permanent",
            totalAmount: 1500,
          },
          {
            service: "Old Residence ",
            policy: "International Permanent",
            totalAmount: 24618.66,
          },
          {
            service: "Return Trip ",
            policy: "International Permanent",
            totalAmount: 8476.79,
          },
          {
            service: "Temporary Living ",
            policy: "International Permanent",
            totalAmount: 467746.12,
          },
          {
            service: "Tenancy Management",
            policy: "International Permanent",
            totalAmount: 15219.87,
          },
          {
            service: "Domestic Lump Sum",
            policy: "International LTA",
            totalAmount: 67500,
          },
          {
            service: "Fee",
            policy: "International LTA",
            totalAmount: 6262,
          },
          {
            service: "Final Move",
            policy: "International LTA",
            totalAmount: 1008.01,
          },
          {
            service: "Others",
            policy: "International LTA",
            totalAmount: 5000,
          },
          {
            service: "Domestic Lump Sum",
            policy: "US Domestic Renter",
            totalAmount: 13000,
          },
          {
            service: "Fee",
            policy: "US Domestic Renter",
            totalAmount: 7981,
          },
          {
            service: "Home Finding ",
            policy: "US Domestic Renter",
            totalAmount: 7630.12,
          },
          {
            service: "Home Sale Assistance",
            policy: "US Domestic Renter",
            totalAmount: 500,
          },
          {
            service: "Household Goods ",
            policy: "US Domestic Renter",
            totalAmount: 79491.24,
          },
          {
            service: "Rental Assistance ",
            policy: "US Domestic Renter",
            totalAmount: 750,
          },
          {
            service: "Cultural Training ",
            policy: "US Domestic Homeowner",
            totalAmount: 4000,
          },
          {
            service: "Domestic Lump Sum",
            policy: "US Domestic Homeowner",
            totalAmount: 439718.16,
          },
          {
            service: "Final Move",
            policy: "US Domestic Homeowner",
            totalAmount: 3704.96,
          },
          {
            service: "Immigration",
            policy: "US Domestic Homeowner",
            totalAmount: 7450,
          },
          {
            service: "Old Residence ",
            policy: "US Domestic Homeowner",
            totalAmount: 4411.33,
          },
          {
            service: "Temporary Living ",
            policy: "US Domestic Homeowner",
            totalAmount: 3039.81,
          },
          {
            service: "Tenancy Management",
            policy: "US Domestic Homeowner",
            totalAmount: 985.04,
          },
          {
            service: "Domestic Lump Sum",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 292712.9,
          },
          {
            service: "Home Finding ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 6643.07,
          },
          {
            service: "Household Goods ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 86894.75,
          },
          {
            service: "New Residence ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 1701.19,
          },
          {
            service: "Others",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 159388.11,
          },
          {
            service: "Return Trip ",
            policy: "US Domestic Assignment - Managed Lump Sum",
            totalAmount: 924.26,
          },
          {
            service: "Fee",
            policy: "Rotational Assignment",
            totalAmount: 5685,
          },
          {
            service: "Final Move",
            policy: "Rotational Assignment",
            totalAmount: 6426.27,
          },
          {
            service: "Home Sale Assistance",
            policy: "Rotational Assignment",
            totalAmount: 67984.05,
          },
          {
            service: "Old Residence ",
            policy: "Rotational Assignment",
            totalAmount: 300001.98,
          },
          {
            service: "Return Trip ",
            policy: "Rotational Assignment",
            totalAmount: 36.62,
          },
          {
            service: "Temporary Living ",
            policy: "Rotational Assignment",
            totalAmount: 51239.99,
          },
          {
            service: "Domestic Lump Sum",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 4000,
          },
          {
            service: "Home Finding ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 36150.95,
          },
          {
            service: "Household Goods ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 584849.52,
          },
          {
            service: "New Residence ",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 15206,
          },
          {
            service: "Others",
            policy: "International STA	Managed Lump Sum",
            totalAmount: 124000,
          },
          {
            service: "Domestic Lump Sum",
            policy: "International Permanent",
            totalAmount: 3487.88,
          },
          {
            service: "Home Finding ",
            policy: "International Permanent",
            totalAmount: 90807.16,
          },
          {
            service: "Household Goods ",
            policy: "International Permanent",
            totalAmount: 1307280.76,
          },
          {
            service: "New Residence ",
            policy: "International Permanent",
            totalAmount: 14418.21,
          },
          {
            service: "Others",
            policy: "International Permanent",
            totalAmount: 212380,
          },
          {
            service: "Home Finding ",
            policy: "International LTA",
            totalAmount: 16,
          },
          {
            service: "Temporary Living ",
            policy: "International LTA",
            totalAmount: 2500,
          },
        ].filter((item) => item.totalAmount > 0),
        startDate: "2020-07-12 00:00:00",
        endDate: "2025-07-18 00:00:00",
      },
    };
    return await axios.post(GET_SERVICE_BY_POLICY, filters);
  }

  private static async getAuthDivisions() {
    const { data }: { data: any } = await axios.get(getDivisions);
    return data;
  }

  public static async getYtdSpendsApi(filters: any) {
    return await dashboardService.getYtdSpends(filters);
  }

  public static async getAssignmentExpCountApi(filters: any) {
    return { data: {} };
    return axios.post(assignmentExpCountURL, filters);
  }

  public static async getYtdAuthorisationsApi(filters: any) {
    return await dashboardService.getYtdAuthorisations(filters);
  }

  public static async getYtdActiveFilesApi(filters: any) {
    return await dashboardService.getYtdActiveFiles(filters);
  }

  public static async getAuthsByPolicyApi(filters: any) {
    return await dashboardService.getAuthsByPolicy(filters);
  }

  public static async getSpendsByPolicyApi(filters: any) {
    return await dashboardService.getSpendsByPolicy(filters);
  }

  public static async getExceptionsByPolicyApi(filters: any) {
    return await dashboardService.getExceptionsByPolicy(filters);
  }

  public static async getAssignmentExpirationApi(filters: any) {
    return { data: {} };
    const types =
      filters.filters?.assignmentType
        ?.filter((item) => item.checked)
        .map((item) => item.id) || [];
    return await axios.post(assignmentExpirationURL, {
      filters: {
        ...filters.filters,
        assignmentType: types.length < 1 ? null : types,
      },
    });
  }

  public static async getVisaExpiryPolicyApi(filters: any) {
    return await dashboardService.getVisaExpiryPolicy(filters);
  }

  public static async getMapsDataApi(filters: any) {
    return await dashboardService.getMapsData(filters);
  }

  public static async getAuthDivisionsApi() {
    return await dashboardService.getAuthDivisions();
  }

  public static async checkFavorite(name: string) {
    return await axios.get(CHECK_FAVOURITE_NAME + "/?name=" + name);
  }

  public static async saveFavorite(data: any) {
    return await axios.put(CREATE_FAVOURITE, data);
  }

  public static async exportData(data: any) {
    return { data: {} };
    return await axios.post(ExportData, data);
  }
}
